<template>
	<!-- <el-select v-model="value1" filterable :placeholder="data.placeholder?data.placeholder:''" :class="classs">
    <el-option v-for="item in areaList1" :label="item.name" :value="item.id">
      <span :class="'grade_'+item.grade">{{item.name}}</span>
    </el-option>
  </el-select> -->
	<el-autocomplete v-model="acVal" icon='' :select-when-unmatched='cChange' oon-icon-click='cChange'
		:fetch-suggestions="querySearchAsync" :props="{label: 'mechanismname', value: 'mechanismname'}"
		:placeholder="$t('app_srcmechan')" @select="handleSelect"></el-autocomplete>
</template>
<script>
	// import Vue from 'vue'
	// Vue.component('my-remote', {
	//   functional: true,
	//   render: function(h, ctx) {
	//     var item = ctx.props.item;
	//     let str = h('li', ctx.data, [
	//       h('div', { attrs: { class: 'name' } }, [item.address]),
	//       h('span', { attrs: { class: 'addr' } }, [item.address])
	//     ]);
	//     if (item.str) { // 根据参数不同 修改原模版结构
	//       str = h('center', { attrs: { class: 'ems' } }, [item.str])
	//     }
	//     return str
	//   },
	//   props: {
	//     item: { type: Object, required: true }
	//   }
	// })
	// import axios from 'axios'
	// import { baseurl,url,focusEvent,urlAssets } from '../../api/url'
	export default {
		name: 'templateName',
		data() {
			return {
				acVal: '',
				value1: "",
				parentId: null,
				areaList1: null,
				datas: [],
				cLock: false,
				isNoInput: true,
				tempWords: '',
			}
		},
		deactivated() {
			this.$destroy(true)
		},
		watch: {
			// value1 (n,o) {
			//   var that = this
			//   if (that.data.callback) {

			//     if (that.data.optValue) {
			//       var tmp;
			//       var len = (that.areaList1)?that.areaList1.length:0;
			//       for(var i = 0; i<len;i++) {
			//         if (that.areaList1[i].id===n) {

			//           tmp = that.areaList1[i];
			//           that.data.callback(tmp, that.areaList1[i])
			//           break;
			//         }
			//       }

			//     } else {
			//       var obj = ''
			//       if (!that.areaList1) return

			//       that.areaList1.forEach((vl) => {
			//         if (vl.id === n) {
			//           obj = vl
			//           return
			//         }
			//       })
			//       that.data.callback(n, obj)
			//     }
			//   }
			// },
			data(n, o) {
				// this.value1 = ''
				// this.init()
				this.setVal()
			}
		},
		props: ["data", "classs", "mselect"],
		methods: {
			cChange() {
				// alert(this.acVal)
				if (!this.acVal) {

					if (this.data.callback) {
						this.data.callback('')
						this.isNoInput = true
					}
				}
			},
			querySearchAsync(queryString, cb) {

				this.tempWords = queryString
				if (this.isNoInput && queryString) {
					this.isNoInput = false
				}
				if (!this.cLock) {
					this.cLock = true
					var _this = this
					setTimeout(() => {
						_this.cLock = false
						_this.tempWords = _this.tempWords ? _this.tempWords : _this.$getWObj().login.mechanismName
						if (_this.tempWords) {
							_this.getList(_this.tempWords, data => {
								cb(data)
							})
						} else {
							cb(this.datas)
							if (this.data.callback) {
								if (!this.isNoInput) {
									this.data.callback('')
									this.isNoInput = true
								}
							}
						}

					}, 2000)
				}

			},
			// createStateFilter(queryString) {
			//   return (state) => {
			//     return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
			//   };
			// },
			handleSelect(item) {

				if (this.data.callback && item) {
					if (item.mechanismid) {
						this.data.callback(item.mechanismid, item)
					} else {
						// this.data.callback('1', '1')
						this.data.callback('', '')
					}

				} else {

					this.data.callback('', '')
				}
			},
			getList(name, callback) {
				// var name = ''
				this.$getChannelList(9999, 1, '', '', name, res => {
					// this.datas = res.datas
					if (callback) callback(res.data)
				}, '')
			},
			getAd1: function() {
				var that = this
				var params = {
					token: localStorage.getItem('user'),
					language: localStorage.getItem("system_lang")
				};
				if (that.parentId) {
					params.parentId = that.parentId
					console.log(JSON.stringify(params, null, 2))
				}
				axios.post(`${baseurl}/mechanism/parent_list.do`, params).then(res => {
					that.areaList1 = res.data.data;
					if (that.data.value) {
						that.value1 = that.data.value
					}
					var comp = function(grade) {
						return function(a, b) {
							return Number(a[grade]) > Number(b[grade]) ? 1 : -1;
						}
					}
					that.areaList1 = that.areaList1.sort(comp('grade'));
					var mTreeSort = function(ttmp, data, id) {
						var forE = (data, id) => {
							for (var i = 0; i < data.length; i++) {
								var item = data[i];
								if (item.pid === id) {
									ttmp.push(item)
									forE(data, item.id)
								} else {
									continue;
								}
							}
						}
						forE(data, id)
						return ttmp
					}
					let level = 0;
					if (that.areaList1 && that.areaList1.length > 0) {
						level = that.areaList1[0]['grade'];
					}
					var rrd = that.areaList1.filter((r) => {
						return r['grade'] === level
					})
					if (rrd.length > 0) {
						var ttmp = []
						ttmp.push(rrd[0])
						mTreeSort(ttmp, that.areaList1, rrd[0]['id'])
						that.areaList1 = ttmp
						if (!that.mselect) {
							var obj = {
								'name': this.$t('lin_global.all_mechanism'),
								'id': ''
							}
							this.areaList1.unshift(obj)
						}
					}
				})
			},
			init() {



				// var that = this
				// if (that.data.value) {
				//   that.parentId = that.data.value
				//   that.value1 = that.data.value
				// }

				// that.getAd1()
			},
			setVal() {
				var vl = this.data.value
				vl = vl ? vl : ''
				this.acVal = vl
			}
		},
		mounted() {
			// this.init()
			this.setVal()
		}
	}
</script>
<style scoped lang="less">
	[v-cloak] {
		display: none;
	}

	.grade_0 {
		/*&::before{*/
		/*content:"--2.";*/
		/*}*/
		/*&::after {*/
		/*content: "(1级)"*/
		/*}*/
	}

	.grade_1 {
		padding-left: 10px;

		/*&::before{*/
		/*content:"\\__2.";*/
		/*}*/
		&::after {
			content: ""
		}
	}

	.grade_2 {
		padding-left: 20px;

		/*&::before{*/
		/*content:"\\__3."*/
		/*}*/
		&::after {
			content: ""
		}
	}

	.grade_3 {
		padding-left: 30px;

		/*&::before{*/
		/*content:"\\__4."*/
		/*}*/
		&::after {
			content: ""
		}
	}

	.grade_4 {
		padding-left: 40px;

		/*&::before{*/
		/*content:"\\__5."*/
		/*}*/
		&::after {
			content: ""
		}
	}

	.grade_5 {
		padding-left: 50px;

		/*&::before{*/
		/*content:"\\__5."*/
		/*}*/
		&::after {
			content: ""
		}
	}

	.grade_6 {
		padding-left: 60px;

		/*&::before{*/
		/*content:"\\__6."*/
		/*}*/
		&::after {
			content: ""
		}
	}

	.grade_7 {
		padding-left: 70px;

		/*&::before{*/
		/*content:"\\__6."*/
		/*}*/
		&::after {
			content: ""
		}
	}

	.grade_8 {
		padding-left: 80px;

		/*&::before{*/
		/*content:"\\__6."*/
		/*}*/
		&::after {
			content: ""
		}
	}
</style>



// WEBPACK FOOTER //
// mechanism_selector.vue?773bfc3b